import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icon.d.ts').IconArrowUp}
 */
const IconArrowUp = ({
    height = 32,
    width = 32
}) => {
    return (
        <svg
            aria-hidden='true'
            fill='none'
            height={height}
            viewBox='0 0 20 20'
            width={width}
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M10.3327 15.166L10.3327 6.12122L14.6804 10.4689L15.166 9.99935L9.99935 4.83268L4.83268 9.99935L5.31831 10.4689L9.66601 6.12122L9.66602 15.166L10.3327 15.166Z'
                fill='currentColor' />
        </svg>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default IconArrowUp;
